import * as React from 'react'
import styled from 'styled-components'
import {theme} from '../theme'
import uusi_suomi from '../../images/uusiSuomi_logo.svg'
import iltalehti from '../../images/iltalehti_logo.svg'
import {RouteComponentProps} from 'react-router'
import {computed} from 'mobx'

export class FinishPage extends React.Component<RouteComponentProps<{candidateId: string}>> {
  @computed
  get candidateId() {
    return this.props.match.params.candidateId
  }
  public render() {
    return (
      <>
        <Content>
          <ThankYouText>
            Kiitos vastauksista. Onnea vaaleihin! <br />
            <br />
            Voit muokata vastauksiasi 21.3. asti. Huomioithan, että vaalikone avautuu yleisölle jo 14.3.
          </ThankYouText>
          <MagazineSectionContainer>
            <img src={iltalehti} />
            <p>
              Iltalehti on Suomen johtava politiikkaa ja yhteiskuntaa käsittelevä media, jota lukee joka viikko lähes kolme miljoonaa
              suomalaista. Voit seurata politiikan uutisia ja puheenaiheita Iltalehden{' '}
              <a href="https://www.iltalehti.fi/politiikka" rel="noreferrer" target="_blank">
                Politiikka-osiossa.
              </a>
            </p>
          </MagazineSectionContainer>
          <MagazineSectionContainer>
            <img src={uusi_suomi} />
            <p>
              Ehdokas, perusta ilmainen blogi{' '}
              <a href="https://puheenvuoro.uusisuomi.fi/perusta-oma-blogi-uuteen-suomeen/" rel="noreferrer" target="_blank">
                Uuden Suomen Puheenvuoroon.
              </a>
            </p>
            <p>Uusi Suomi on yhteiskunnallinen uutis- ja blogipalvelu, jolla on yhteensä noin 500 000 lukijaa viikossa.</p>
          </MagazineSectionContainer>
        </Content>
      </>
    )
  }
}

const ThankYouText = styled.p`
  padding-bottom: 7rem;
  border-bottom: 1px solid ${theme.color.gray};
`

const MagazineSectionContainer = styled.section`
  margin-top: 4rem;
  p {
    font-size: 1.9rem;
    a {
      color: #000000;
    }
  }
`

const Content = styled.div`
  padding: 2rem 6.5rem 0 12.8rem;
  min-height: 590px;
  @media screen and (max-width: ${theme.breakPoints.mobileLandscape}px) {
    padding: 2rem 3rem 0 6rem;
  }
  @media screen and (max-width: ${theme.breakPoints.mobileMax}px) {
    padding: ${theme.layout.mobileContentPadding};
    font-size: 1.9rem;
    min-height: 400px;
  }
  font-size: 2.2rem;
  font-weight: 500;
`
